import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckBoxOptions, EnglishArabicDTO, FilterItem, FilterType, InputType, MultiLingualTextAreaOptions, MultiLingualTextBoxOptions, PagingOptions, TextBoxOptions } from 'bbsf-controls';
import { HelpCenterService } from '../../shared/Services/HelpCenterService.service';
import { HelpCenterItemModel } from '../../shared/models/HelpCenterModels/HelpCenterItemModel';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bbsf-utilities';

@Component({
  selector: 'lib-help-center-secondlevel',
  templateUrl: './help-center-secondlevel.component.html'
})
export class HelpCenterSecondlevelComponent implements OnInit {

  ApiUrl = "/api/admin/HelpCenter/"
  searchTextBox: TextBoxOptions;
  ParentIdTextBox: TextBoxOptions;
  PermissionSetsList = [];
  HelpCenterForm = new FormGroup({});
  showFilter: boolean = false;
  HelpCenterPagingResult: any[] = [];
  HelpCenterPaging: PagingOptions;
  TextInputFilter: FilterItem;
  ParentIDFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ParentId: string = ""
  ParentName:string=""
  PageName: string = ""
  HelpCenter: HelpCenterItemModel = new HelpCenterItemModel();
  ProductionMode: boolean = false;
  @ViewChild('HelpCenterPagingViewElement', { static: false }) input: ElementRef;

  language: string = ""

  //Add Model Controls
  AddHelpCenterForm = new FormGroup({});
  MultiLingualTitle:MultiLingualTextBoxOptions
  MultiLingualDescription:MultiLingualTextAreaOptions
  AddIsHidden: CheckBoxOptions;
  IsAddHelpCenterFormLoaded: boolean = false;
  @ViewChild('CloseAddHelpCenterModal', { static: false }) CloseAddHelpCenterModal: ElementRef;

  //Edit Model Controls
  EditHelpCenterForm = new FormGroup({});
  EditMultiLingualTitle:MultiLingualTextBoxOptions
  EditMultiLingualDescription:MultiLingualTextAreaOptions
  EditIsHidden: CheckBoxOptions;
  HelpCenterItemId: number;

  IsEditHelpCenterModalLoaded: boolean = false;
  @ViewChild('CloseEditHelpCenterModal', { static: false }) CloseEditHelpCenterModal: ElementRef;

  //delete  Model Controls
  IsOpenDeleteHelpCenterModal: boolean = false;
  deleteHelpCenterId: string;
  @ViewChild('CloseDeleteHelpCenterItemModal', { static: false }) CloseDeleteHelpCenterItemModal: ElementRef;


  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private activatedRoute: ActivatedRoute, private HelpCenterService: HelpCenterService, private modalService: NgbModal) {
    this.activatedRoute.params.subscribe(params => {
      this.ParentId = params['parentID'];
    });    
  }

  async ngOnInit(): Promise<void> {
    this.ParentName = localStorage.getItem("ParentName");
    this.PageName = this.ParentName
    PageInfoService.PageTitle=this.PageName
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false},
       {title: this.utilityService.getResourceValue("HelpCenter") , path: '/Admin/HelpCenter/HelpCenter', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false},
      
  
    ]; 

    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    
    this.LoadList();
  }
 
  //initialize filters and load any drop down list
  LoadList() {
      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
      this.searchTextBox.HideLabel = true

      this.ParentIdTextBox = new TextBoxOptions();
    this.ParentIdTextBox.Name = "ParentIdTextBox"
    this.ParentIdTextBox.HideLabel = true
      this.ParentIdTextBox.Type = InputType.Text
      this.ParentIdTextBox.Value = this.ParentId;

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.ParentIDFilter = new FilterItem();
      this.ParentIDFilter.FormControlName = "ParentIdTextBox"
      this.ParentIDFilter.ActionParameterName = "parentID"
      this.ParentIDFilter.IsFormControl = true
      this.ParentIDFilter.FilterType = FilterType.TextBox
      

      this.HelpCenterPaging = new PagingOptions();
       ;
      this.HelpCenterPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetHelpCenterItemsByFilter';
      this.HelpCenterPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.HelpCenterPaging.Filters = [this.TextInputFilter, this.ParentIDFilter]
      this.HelpCenterPaging.ValidationToken = this.authService.authorizationHeaderValue()

      setTimeout(() => {
        this.IsFilterLoaded = true;
      }, 10);
  }



  ReinitializeHelpCenterPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateHelpCenterPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setHelpCenterItemListResult(result) {
    this.HelpCenterPagingResult = result;
     //console.log(this.HelpCenterPagingResult);

  }

  resetFilters() {
    this.HelpCenterForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  showAddHelpCenterModal(AddHelpCenterModal) {
 
    this.utilityService.startBlockUI();
    this.AddHelpCenterForm = new FormGroup({})

    this.MultiLingualTitle = new MultiLingualTextBoxOptions();
    this.MultiLingualTitle.Name = "Title";
    this.MultiLingualTitle.ArabicLabelKey =  "TitleInArabic";
    this.MultiLingualTitle.EnglishLabelKey = "TitleInEnglish";
    this.MultiLingualTitle.IsRequired = true;
    this.MultiLingualTitle.Value = null;

    this.MultiLingualDescription = new MultiLingualTextAreaOptions();
    this.MultiLingualDescription.Name = "Description";
    this.MultiLingualDescription.ArabicLabelKey =  "DescriptionInArabic";
    this.MultiLingualDescription.EnglishLabelKey = "DescriptionInEnglish";
    this.MultiLingualDescription.IsRequired = true;
    this.MultiLingualDescription.Value = null;


    this.AddIsHidden = new CheckBoxOptions();
    this.AddIsHidden.Name = "AddIsHidden"
    this.AddIsHidden.LabelKey = "Hidden"
    this.AddIsHidden.Value = false

    this.modalService.open(AddHelpCenterModal);
    this.utilityService.stopBlockUI();

  }

  addHelpCenterItem() {
    if (this.AddHelpCenterForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddHelpCenterForm.value;
       //console.log(ResultModel);
      let AddModel: HelpCenterItemModel = new HelpCenterItemModel();
      AddModel.Title.Arabic = ResultModel.Title.ArabicValue;
      AddModel.Title.English = ResultModel.Title.EnglishValue;
      AddModel.Description.Arabic = ResultModel.Description.ArabicTextAreaValue;
      AddModel.Description.English = ResultModel.Description.EnglishTextAreaValue;
      AddModel.IsHidden = ResultModel.AddIsHidden;
      AddModel.ParentIDEncrypted = this.ParentId;



      this.HelpCenterService.AddHelpCenter(AddModel).subscribe((result) => {
         
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      
      })
    }
  }
  showEditHelpCenterModal(HelpCenter: any, EditHelpCenterModal) {

    this.utilityService.startBlockUI();
    this.EditHelpCenterForm = new FormGroup({})

    this.HelpCenterItemId = HelpCenter.id

    let Title=new EnglishArabicDTO();
    Title.Arabic= HelpCenter.title.arabic;
    Title.English= HelpCenter.title.english;

    this.EditMultiLingualTitle = new MultiLingualTextBoxOptions();
    this.EditMultiLingualTitle.Name = "Title";
    this.EditMultiLingualTitle.ArabicLabelKey =  "TitleInArabic";
    this.EditMultiLingualTitle.EnglishLabelKey = "TitleInEnglish";
    this.EditMultiLingualTitle.IsRequired = true;
    this.EditMultiLingualTitle.Value = Title;

    let Description=new EnglishArabicDTO();
    Description.Arabic= HelpCenter.description.arabic;
    Description.English= HelpCenter.description.english;

    this.EditMultiLingualDescription = new MultiLingualTextAreaOptions();
    this.EditMultiLingualDescription.Name = "Description";
    this.EditMultiLingualDescription.ArabicLabelKey =  "DescriptionInArabic";
    this.EditMultiLingualDescription.EnglishLabelKey = "DescriptionInEnglish";
    this.EditMultiLingualDescription.Value = Description;
    

    this.EditIsHidden = new CheckBoxOptions();
    this.EditIsHidden.Name = "EditIsHidden"
    this.EditIsHidden.LabelKey = "Hidden"
    this.EditIsHidden.Value = HelpCenter.isHidden

    this.modalService.open(EditHelpCenterModal);
    this.utilityService.stopBlockUI();


  }

  editHelpCenter() {
    if (this.EditHelpCenterForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditHelpCenterForm.value;
      let EditModel = new HelpCenterItemModel();
      EditModel.ID = Number(this.HelpCenterItemId);
      EditModel.Title.English = ResultModel.Title.EnglishValue; //(##1)
      EditModel.Title.Arabic = ResultModel.Title.ArabicValue;
      EditModel.Description.English = ResultModel.Description.EnglishTextAreaValue;
      EditModel.Description.Arabic = ResultModel.Description.ArabicTextAreaValue;
      EditModel.IsHidden = ResultModel.EditIsHidden;

      this.HelpCenterService.EditHelpCenter( EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      })
    }
  }

  showDeleteHelpCenterModal(Item: any, deleteHelpCenterItemModal) {
    this.deleteHelpCenterId = Item.idEncrypted;
    this.utilityService.startBlockUI();
    this.modalService.open(deleteHelpCenterItemModal);
    this.utilityService.stopBlockUI();


  }

  deleteHelpCenter() {
    this.HelpCenterService.DeleteHelpCenter(this.deleteHelpCenterId).subscribe((result) => {
      this.deleteHelpCenterId = "";
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    })

  }

  SaveName(name) {
    localStorage.setItem("ParentName", name);
  }
 }


